import { create } from 'zustand';
import { IUserModel, ModelType } from '@packages/global';
import { modelApi } from '../services/user/model.api';

interface ModelState {
  models: IUserModel[];
  loading: boolean;
  lastFetchTime: number | null;
  fetchModels: () => Promise<void>;
  getModelsByType: (type: ModelType) => IUserModel[];
  getModelById: (id: string) => IUserModel | undefined;
  clearCache: () => void;
}

const CACHE_DURATION = 2 * 60 * 1000; // 2分钟缓存

export const useModelStore = create<ModelState>((set, get) => ({
  models: [],
  loading: false,
  lastFetchTime: null,

  fetchModels: async () => {
    const { lastFetchTime, loading } = get();
    const now = Date.now();

    // 如果正在加载或缓存未过期，直接返回
    if (loading || (lastFetchTime && now - lastFetchTime < CACHE_DURATION)) {
      return;
    }

    set({ loading: true });
    try {
      const models = await modelApi.getAllModels();
      set({
        models,
        loading: false,
        lastFetchTime: now
      });
    } catch (error) {
      console.error('获取模型列表失败:', error);
      set({ loading: false });
    }
  },

  getModelsByType: (type: ModelType) => {
    const { models } = get();
    return models.filter(model => model.modelType === type);
  },

  getModelById: (id: string) => {
    const { models } = get();
    return models.find(model => model.id === id);
  },

  clearCache: () => {
    set({ models: [], lastFetchTime: null });
  }
}));
